import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state: () => ({
    app_ready: false,
    user: null,
    config: null,
    user_activity: null,
    commentable_post: null,
    wall_filter: null,
    overlay: null,
    // statistics: null,
  }),
  getters: {

  },
  actions: {
    setAppReady(ready) {
      this.app_ready = ready;
    },

    setUser(user) {
      this.user = user;
    },

    setConfig(config) {
      this.config = config;
    },

    setUserActivity(user_activity) {
      this.user_activity = user_activity;
    },

    setCommentablePost(post) {
      this.commentable_post = post;
    },

    setWallFilter(id, name = '', taxonomy = 'tags') {
      this.wall_filter = id == null ? null : { id, name, taxonomy };
    },

    setOverlay( overlay ) {
      this.overlay = overlay;
    },

    /* setStatistics(statistics) {
      this.statistics = statistics;
    }, */
  },
})
